const CONTENT = {
    POSTS: 'POSTS',
    PACKAGES: 'PACKAGES',
};

export default CONTENT;
